





















































import ALPage from '@/components/core/Page/ALPage.vue';
import Vue from 'vue';
import { DataTableHeader } from 'vuetify';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'CustomerAddressListPage',

  components: { ALPage },

  data() {
    return {
      customer: {},

      search: '',

      dialog: false,
      loading: false,

      addressHeaders: [
        {
          text: 'Customer',
          align: 'start',
          sortable: false,
          width: 103,
          value: 'customer'
        },
        { text: 'Name', value: 'name', width: 320 },
        { text: 'Address1', value: 'address1', width: 280 },
        { text: 'Address2', value: 'address2', width: 280 },
        { text: 'City', value: 'city', width: 200 },
        { text: 'Region', value: 'region' },
        { text: 'Country', value: 'country', width: 150 },
        { text: 'Postal code', value: 'postal_code', width: 100 }
      ] as DataTableHeader[]
    };
  },

  computed: {
    ...mapGetters({
      getCustomerById: 'customer/getCustomerById'
    })
  },

  methods: {
    ...mapActions({
      fetchCustomer: 'customer/fetchCustomer'
    }),

    async tryGetOrFetchConfiguration(customerId: string) {
      try {
        let customer = this.getCustomerById(customerId);

        if (!customer) {
          this.loading = true;
          await this.fetchCustomer(customerId);
          this.loading = false;
          customer = this.getCustomerById(customerId);
        }
        return customer;
      } catch (e) {
        this.loading = false;
        // TODO: We need to handle error appropriately - Show error message
        console.warn('Customer Not Found: ', e);
        return null;
      }
    }
  },

  async mounted() {
    this.customer = await this.tryGetOrFetchConfiguration(
      this.$route.params.customerId
    );
  }
});
